import { render, staticRenderFns } from "./NotificationsPopup.vue?vue&type=template&id=14c8de06&scoped=true&"
import script from "./NotificationsPopup.vue?vue&type=script&lang=js&"
export * from "./NotificationsPopup.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsPopup.vue?vue&type=style&index=0&id=14c8de06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c8de06",
  null
  
)

export default component.exports